import { Component, ElementRef, ViewChild, OnInit, Injector, AfterViewInit } from '@angular/core';
import { PoAvatarComponent } from '@po-ui/ng-components';
import { ContextModalComponent } from '../contextmodal/contextmodal.component';
import { PageBase } from 'src/app/shared/library/page.base';
import { ContextCockpit } from 'src/utils/enums';


@Component({
    selector: 'app-contexttoolbar',
    templateUrl: './contexttoolbar.component.html',
    styleUrls: ['./contexttoolbar.component.css'],
    standalone: false
})

export class ContextToolbarComponent extends PageBase implements OnInit, AfterViewInit {

  @ViewChild('target', { read: ElementRef, static: true }) poAvatar: PoAvatarComponent;
  @ViewChild(ContextModalComponent, { static: true }) poModal: ContextModalComponent;
  @ViewChild('TrocarProjeto') trocarProjeto: ElementRef;
  @ViewChild('TrocarProjetoIcon') trocarProjetoIcon: ElementRef;
  @ViewChild('TrocarProjetoText') trocarProjetoText: ElementRef;

  User: string = '';
  Logototvssmall = './assets/icone-totvs-p.png';
  Logototvsmedium = './assets/icone-totvs-m.png';

  constructor(public ObjInjector: Injector) {
    super(ObjInjector);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.User = this.contextApplication.Usuario.username;
  }

  ngAfterViewInit(): void {
    if (this.contextApplication.ContextCockpit.valueOf() === ContextCockpit.RM.valueOf()) {
      this.trocarProjetoIcon.nativeElement.setAttribute('class', 'po-icon po-icon-settings cp-title-bar-disabled');
      this.trocarProjetoText.nativeElement.setAttribute('class', 'cp-title-bar-disabled');
    }
  }

  openModal(): void {
    if (this.contextApplication.ContextCockpit.valueOf() === ContextCockpit.RM.valueOf())
      return;

    this.poModal.openModal();
  }

  Logout(): void {
    this.contextApplication.hiddenResultsDashboardTaskInput();
    this.contextApplication = undefined;
    sessionStorage.clear();
    this.router.navigate(['']);
  }

  onReceiveLiterals() { }
}
